import React, { useState, useEffect, useRef } from "react";
import "./Est.css";

const Music = () => {
	const [imageOne, setImageOne] = useState(500);
	const [imagetwo, setImagetwo] = useState(500);
	const [imagethree, setImagethree] = useState(500);
	const img1Ref = useRef(null);
	const img2Ref = useRef(null);
	const img3Ref = useRef(null);
	useEffect(() => {
		const handleScroll = () => {
			const el = document.querySelector(".estDiv");
			const textEl = document.querySelector(".estText");

			if (
				!el ||
				!textEl ||
				!img1Ref.current ||
				!img2Ref.current ||
				!img3Ref.current
			)
				return;

			const screenBottom = window.innerHeight;
			const elPos = el.getBoundingClientRect().top;

			if (elPos < screenBottom && elPos + 150 > 0) {
				textEl.style.visibility = "visible";
				textEl.style.opacity = "1";
				textEl.style.transform = "translateX(0)";
			} else {
				textEl.style.visibility = "hidden";
				textEl.style.opacity = "0";
				textEl.style.transform = "translateX(-300px)";
			}

			const updateImage = (rect, setter) => {
				setter(rect.bottom - 50 < screenBottom ? 0 : 500);
			};

			updateImage(img1Ref.current.getBoundingClientRect(), setImageOne);
			updateImage(img2Ref.current.getBoundingClientRect(), setImagetwo);
			updateImage(img3Ref.current.getBoundingClientRect(), setImagethree);
		};

		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, []);

	return (
		<div className='est'>
			<div className='estText'>
				<h2>Das solltest du vor deinem Rundflug wissen</h2>

				<p>
					Damit dein Erlebnis sicher, komfortabel und stressfrei wird, gibt es
					nur wenige einfache Voraussetzungen.
				</p>

				<ul>
					<li>
						Mindestalter: ab ca. 12 Jahren (mit Einverständnis der Eltern)
					</li>
					<li>Maximalgewicht: bis 100 kg (inkl. Kleidung & Schuhen)</li>
					<li>Kleidung: feste Schuhe, lange Hose und eine winddichte Jacke</li>
					<li>
						Gesundheit: normale körperliche Verfassung, keine akuten Beschwerden
					</li>
					<li>Wetter: Flüge sind immer wetterabhängig – Sicherheit geht vor</li>
				</ul>
			</div>

			<img
				ref={img1Ref}
				style={{ transform: `translateX(${imageOne}%)` }}
				id='img1'
				src='./img/Est/image1.png'
				alt=''
				className='image1'
			/>
			<img
				ref={img2Ref}
				style={{ transform: `translateX(${imagetwo}%)` }}
				id='img2'
				src='./img/Est/image2.png'
				alt=''
				className='image2'
			/>
			<img
				ref={img3Ref}
				style={{ transform: `translateX(${imagethree}%)` }}
				id='img3'
				src='./img/Est/image3.png'
				alt=''
				className='image3'
			/>
		</div>
	);
};

export default Music;
